import PostOrder from '@/language/en/components/post/PostOrder';

export default {
  PostOrder,
};
